__turbopack_context__.v({
  "caption": "GalleryTab-module__piWb5G__caption",
  "card": "GalleryTab-module__piWb5G__card",
  "cardOverlay": "GalleryTab-module__piWb5G__cardOverlay",
  "desktopColumns": "GalleryTab-module__piWb5G__desktopColumns",
  "desktopHeader": "GalleryTab-module__piWb5G__desktopHeader",
  "desktopSticky": "GalleryTab-module__piWb5G__desktopSticky",
  "desktopTrack": "GalleryTab-module__piWb5G__desktopTrack",
  "filterBtn": "GalleryTab-module__piWb5G__filterBtn",
  "filterBtnActive": "GalleryTab-module__piWb5G__filterBtnActive",
  "filters": "GalleryTab-module__piWb5G__filters",
  "galleryEventsSection": "GalleryTab-module__piWb5G__galleryEventsSection",
  "galleryImage": "GalleryTab-module__piWb5G__galleryImage",
  "grid": "GalleryTab-module__piWb5G__grid",
  "highlightsTitle": "GalleryTab-module__piWb5G__highlightsTitle",
  "imageWrapper": "GalleryTab-module__piWb5G__imageWrapper",
  "mobileCaption": "GalleryTab-module__piWb5G__mobileCaption",
  "mobileCard": "GalleryTab-module__piWb5G__mobileCard",
  "mobileHeader": "GalleryTab-module__piWb5G__mobileHeader",
  "mobileImageWrapper": "GalleryTab-module__piWb5G__mobileImageWrapper",
  "mobileRow": "GalleryTab-module__piWb5G__mobileRow",
  "mobileRowMask": "GalleryTab-module__piWb5G__mobileRowMask",
  "mobileRows": "GalleryTab-module__piWb5G__mobileRows",
  "mobileSticky": "GalleryTab-module__piWb5G__mobileSticky",
  "mobileTrack": "GalleryTab-module__piWb5G__mobileTrack",
  "overlayButton": "GalleryTab-module__piWb5G__overlayButton",
  "parallaxCaption": "GalleryTab-module__piWb5G__parallaxCaption",
  "parallaxCol": "GalleryTab-module__piWb5G__parallaxCol",
  "parallaxFigure": "GalleryTab-module__piWb5G__parallaxFigure",
  "parallaxImageWrapper": "GalleryTab-module__piWb5G__parallaxImageWrapper",
  "viewMoreBtn": "GalleryTab-module__piWb5G__viewMoreBtn",
});
